import { useEffect, useState } from 'react';

const DEFAULT_TIMEOUT = 500;

export function useDebounce<T>(value: T, delay = DEFAULT_TIMEOUT) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler: NodeJS.Timeout = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
